"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Loading',
  props: {
    loaded: Boolean,
    loading: Boolean
  }
  // created() - media_750 import removed for PC compatibility
};